const SirTrevor = require('sir-trevor');
const _ = require('lodash');

module.exports = (function(){

  var md_template = _.template([
    '<div class="st-controllable-block">',
    '<div class="st-controllable-block__content"><textarea class="st-controllable-block__text st-controllable-block__text--html st-required"></textarea></div>',
    '<div class="st-controllable-block__footer">HTML</div>',
    '</div>'
  ].join("\n"));

  return SirTrevor.Block.extend({
    type: "html",
    icon_name: "quote",
    title: () => "HTML",

    editorHTML: function() {
      return md_template(this);
    },

    loadData: function(data) {
      this.el.querySelector('.st-controllable-block__text').innerHTML = data.html;
    },

    _serializeData: function() {
      return {
        html: this.el.querySelector('.st-controllable-block__text').value
      };
    },

    focus: function() {
      this.el.querySelector('.st-controllable-block__text').focus()
    }
  });
})();
